import { Fragment, memo, type ReactNode } from 'react';

import { type BoolStateValue, useBoolState } from '../../hooks/useBoolState';

export type BoolStateProps = {
  // Initial state of the boolean. Defaults to false.
  initial?: boolean;
  children?: (boolState: BoolStateValue) => ReactNode | undefined;
};

const defaultChildren = () => null;

export const BoolStateBase = ({ initial = false, children = defaultChildren }: BoolStateProps) => {
  const boolState = useBoolState(initial);

  return <Fragment>{children(boolState)}</Fragment>;
};

BoolStateBase.displayName = 'BoolState';

export const BoolState = memo(BoolStateBase);
